<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JV8tY8/tc-custom/9781426824432.jpg?1731055900515" alt="This image is the cover for the book Kansas City Christmas, The Precinct: Brotherhood of the Badge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kansas City Christmas, The Precinct: Brotherhood of the Badge
      </h1>
      <p class="bookDescription body article font2">
        <b>A widowed ex-cop must save a medical examiner from a deadly stalker in this romantic suspense thriller from a <i>USA Today</i>–bestselling author.</b><br/><br/>A detective with no badge, Edward Kincaid’s brooding nature scared medical examiner Holly Masterson, but couldn’t dim her holiday spirit. It was when she attracted a stalker that the most wonderful time of the year turned into the most frightening. Working together to reveal a conspiracy too many people had died covering up, Holly found Edward’s protection—and powerful embrace—hard to resist. Now, as new clues surfaced, could she bust the case wide open and give her silent knight the Christmas miracle he deserved?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Miller
      </h2>
      
      <p class="authorDescription body article">USA TODAY bestselling author Julie Miller writes breathtaking romantic suspense. She has sold millions of copies of her books worldwide, and has earned a National Readers Choice Award, two Daphne du Maurier prizes and an RT BookReviews Career Achievement Award. For a complete list of her books and more, go to <a href="http://www.juliemiller.org">www.juliemiller.org</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46f3525d